import { Box, Button, Container, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import BackBtn from "../../widgets/BackBtn";
import PageTitle from "../../widgets/PageTitle";
import { getHeader, toastError } from "../../utils/util";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
import { toast } from "react-toastify";

const LinkProjectToAccount = () => {
  const [formData, setFormData] = useState({
    project_id: "",
    waba_id: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axios.post(
        `${API_ENDPOINT}/partner/link-project-waba`,
        {
          assistantId: formData.project_id,
          wabaAppId: formData.waba_id,
        },
        getHeader()
      );
      toast.success(response.data.message);
      setSuccess(true);
      setFormData({ project_id: "", waba_id: "" });
    } catch (error) {
      toastError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 3 }}>
      <BackBtn />
      <PageTitle>Link Project to WhatsApp Business Account</PageTitle>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          mt: 4,
          p: 4,
          borderRadius: 2,
          boxShadow: 1,
          backgroundColor: "background.paper",
        }}
      >
        <Typography variant="h6" gutterBottom>
          Account Linking Details
        </Typography>

        <TextField
          fullWidth
          margin="normal"
          label="Project ID"
          name="project_id"
          value={formData.project_id}
          onChange={handleChange}
          required
          helperText="Enter the Project ID"
        />

        <TextField
          fullWidth
          margin="normal"
          label="WhatsApp Business Account ID (WABA ID)"
          name="waba_id"
          value={formData.waba_id}
          onChange={handleChange}
          required
          helperText="Enter the WhatsApp Business Account ID"
        />

        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            Error: {error}
          </Typography>
        )}

        {success && (
          <Typography color="success.main" sx={{ mt: 2 }}>
            Project successfully linked to WhatsApp Business Account!
          </Typography>
        )}

        <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
          <Button
            type="submit"
            variant="contained"
            size="large"
            sx={{ px: 4 }}
            disabled={isLoading}
          >
            {isLoading ? "Linking..." : "Link Account"}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default LinkProjectToAccount;
